import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  
  constructor(private afAuth: AngularFireAuth, private router: Router) {

    this.afAuth.authState.subscribe(user => {
      const bInfo =  localStorage.getItem('businessData')
      if (user && bInfo) {
        this.router.navigate(['/home']);
      } else {
        localStorage.clear();
        this.router.navigate(['/login']);
      }
    });
  }
}
